import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/dpp`;

export const dppService = {
  // Step 1: Data Compilation
  getProducts: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/products`, { params });
    return response.data;
  },

  getProductDetail: async (id) => {
    const response = await axios.get(`${API_BASE}/products/${encodeURIComponent(id)}`);
    return response.data;
  },

  // DPP Metadata (ESPR-specific fields)
  getMetadataList: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/metadata`, { params });
    return response.data;
  },

  getMetadataDetail: async (id) => {
    const response = await axios.get(`${API_BASE}/metadata/${encodeURIComponent(id)}`);
    return response.data;
  },

  createMetadata: async (data) => {
    const response = await axios.post(`${API_BASE}/metadata`, data);
    return response.data;
  },

  // Claim Submission
  submitClaim: async (productFootprintId) => {
    const response = await axios.post(`${API_BASE}/claims/submit`, {
      product_footprint_id: productFootprintId
    });
    return response.data;
  },

  // Step 4: Final DPP Issuance
  getIssuanceList: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/issuance`, { params });
    return response.data;
  },

  issueDPP: async (id) => {
    const response = await axios.post(`${API_BASE}/issuance/${encodeURIComponent(id)}`);
    return response.data;
  },

  getQRCodeData: async (batchId) => {
    const response = await axios.get(`${API_BASE}/qr/${encodeURIComponent(batchId)}`);
    return response.data;
  },

  // Statistics
  getStats: async () => {
    const response = await axios.get(`${API_BASE}/stats`);
    return response.data;
  },
};

export default dppService;
